import { $host, $authHost, isDev } from './index'
import { jwtDecode } from 'jwt-decode'
import { httpPoint } from '../utils/const'

import FingerprintJS from "@fingerprintjs/fingerprintjs";

const loadFingerprint = async () => {
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    return result.visitorId
  };

export const signin = async (login, password) => {
    const fingerprintjs = await loadFingerprint()
    const { data } = await $host.post(httpPoint.user + 'login', { login, password, fingerprintjs })
    return data
}

export const registration = async (login, password, email, type, timezone, rules) => {
    const fingerprintjs = await loadFingerprint()

    const { data } = await $host.post(httpPoint.user + 'registration', { login, password, email, type, timezone, rules, fingerprintjs })

    return data
}

export const check = async () => {
    const token = localStorage.getItem('token')
  
    if (!token) return null
  
    try {
      const fingerprintjs = await loadFingerprint()
      const { data } = await $authHost.post('auth/check', {fingerprintjs})
  
      // если сервер сказал что токен невалиден
      if (!data || !data.user) {
        localStorage.removeItem('token')
        return null
      }
  
      if (data.token) {
        localStorage.setItem('token', data.token)
      }
  
      return data
    } catch (e) {
      // важно: при любой ошибке — разлогиниваем
      localStorage.removeItem('token')
      return null
    }
  }

export const updateAvatar = async (formData) => {
    const { data } = await $authHost.post(httpPoint.user + 'update-avatar', formData);
    return data
}

export const removeAvatar = async () => {
    const { data } = await $authHost.post(httpPoint.user + 'remove-avatar');
    return data
}

export const getUserInfo = async () => {
    const { data } = await $authHost.post(httpPoint.user + 'info');
    return data
}

export const upUserInfo = async (payload) => {
    const { data } = await $authHost.post(httpPoint.user + 'update-info', payload);
    return data
}

